import React from 'react';
import { Header, Icon, Loader } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProductsAndQuotation } from '../helpers/hooks';
import Stepper from './Stepper';

const QuotationTypeSelect = ({ history: { push }, match: { params } }) => {
  const { t } = useTranslation();
  const { quotation } = useProductsAndQuotation(params.id);

  if (quotation === undefined) return <Loader active inline="centered" />;

  return (
    <>
      <Stepper step={2} />
      <Header as="h3">{t('Round 2')}</Header>
      <Header as="h2">{t('What do you want to quote?')}</Header>
      <p className="quotation-type-intro">{t('Choose how you want to create your quotation.')}</p>
      <div className="quotation-choice-grid">
        <button type="button" className="quotation-choice quotation-choice-console" onClick={() => push(`/quotation/${params.id}/items`)}>
          <Icon name="gamepad" />
          <span className="quotation-choice-title">{t('Console and other items')}</span>
          <span className="quotation-choice-description">{t('Consoles, games, phones, accessories and more.')}</span>
          <span className="quotation-choice-action">{t('Add items')} <Icon name="arrow right" /></span>
        </button>
        <button type="button" className="quotation-choice quotation-choice-pc" onClick={() => push(`/quotation/${params.id}/pc`)}>
          <Icon name="desktop" />
          <span className="quotation-choice-title">{t('Build my PC')}</span>
          <span className="quotation-choice-description">{t('Add each computer component on a single screen.')}</span>
          <span className="quotation-choice-action">{t('Start building')} <Icon name="arrow right" /></span>
        </button>
      </div>
    </>
  );
};

export default withRouter(QuotationTypeSelect);
